import React from 'react';
import cn from 'classnames';
import { Button } from "../../../../ui/CTA";
import styles from './SizePickerActionButton.module.scss';
import { icons } from './types';
const SizePickerActionButton = ({ children, icon = 'bag', disabled, title, isIconVisible = true, onClick, nibIconSize = 'small', }) => {
    if (!children) {
        return null;
    }
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (onClick) {
                onClick();
            }
        }
    };
    const IconComp = icons[icon];
    return (React.createElement(Button, { "aria-label": title, disabled: disabled, className: cn(isIconVisible && styles.notifyIfBackBtn), fullWidth: true, iconElement: isIconVisible && (React.createElement(IconComp, { className: cn(disabled ? styles.iconDisabled : styles.iconEnabled), size: nibIconSize })), onClick: onClick, onKeyDown: handleKeyDown }, children));
};
export default SizePickerActionButton;
//# sourceMappingURL=SizePickerActionButton.js.map